// extracted by mini-css-extract-plugin
export var addressFields = "_ns-0";
export var animationContainer = "_ns-1";
export var footer = "_ns-2";
export var lineItems = "_ns-3";
export var modalContent = "_ns-4";
export var orderName = "_ns-5";
export var strong = "_ns-6";
export var warning = "_ns-7";